import { tryParse } from '@/utils/try-parse'

const dataExpiryValue = sessionStorage.getItem('dataExpiry');

const initialState = {
	storeDays: tryParse(dataExpiryValue)?.storeDays ?? null,
	receiveDays: tryParse(dataExpiryValue)?.receiveDays ?? null,
	error: null
}

function dataExpiry(state = initialState, action) {
	switch (action.type) {
		case 'dataExpiry/set': {
			return {
				...state,
				storeDays: action.payload.storeDays,
				receiveDays: action.payload.receiveDays
			}
		}
		case 'dataExpiry/error': {
			return {
				...state,
				error: action.payload,
			}
		}
		default: {
			return state
		}
	}
}

export default dataExpiry
